import React, { useState } from 'react';
import { PaymentProvider } from '../../../../XV2';
import { UiGrid } from '@open-stack/ui';
import { useAsync } from '../../../../hooks/useAsync';
import { ProviderBamboraButton } from '../../bambora/button/ProviderBamboraButton';
import { useZone } from '../../../../hooks/zone';
import { XAlert, XAlertType } from '../../../x/alert/XAlert';
import { apiProviderPaymentVippsPreparePost } from '../../../../api/provider.payment.vipps.prepare.[post]';
import { utilLog } from '../../../../util/utilLog';

interface Props {
    config: {};
    onSuccess: any;
}

export function ProviderPayVipps({ config, onSuccess }: Props) {
    const { zoneId } = useZone();
    const [noResponse, setNoResponse] = useState(false);

    const handleProvider = useAsync(async (provider) => {
        setNoResponse(false);

        const response = await apiProviderPaymentVippsPreparePost({
            body: { ...config, zoneId, provider },
        });

        const { data } = response as {
            data: {
                url: string;
            };
        };

        utilLog(response);

        if (data?.url) {
            window.location.href = response.data.url;
        }

        await new Promise((r) => setTimeout(r, 5000));

        setNoResponse(true);
    });

    return (
        <UiGrid>
            {noResponse && (
                <XAlert type={XAlertType.WARNING}>
                    <div>
                        You should have been asked to open Vipps app. If you didn't get the message, make sure you have
                        Vipps app installed
                    </div>
                </XAlert>
            )}

            <ProviderBamboraButton
                provider={PaymentProvider.BAMBORA_VIPPS}
                onClick={() => handleProvider.run(PaymentProvider.VIPPS)}
                isLoading={handleProvider.isLoading}>
                Vipps
            </ProviderBamboraButton>
        </UiGrid>
    );
}
